import React from 'react'
import R from 'ramda'
import { Row, Col } from 'react-bootstrap'
import EditableTable from '_/shared/components/editableTable'
import ensureNumber from '_/utils/ensureNumber'
import { List } from 'immutable'
import TransactionDetail from './transactionDetail'

/**
 * Income and expenses detail page
 */
class IncExpDetail extends React.Component {
  static propTypes = {
    account: React.PropTypes.object.isRequired,
    metadata: React.PropTypes.object.isRequired,
    transaction: React.PropTypes.object.isRequired,
    link: React.PropTypes.func.isRequired,
    errors: React.PropTypes.object,
    onCertify: React.PropTypes.func.isRequired,
    editing: React.PropTypes.bool
  }

  constructor (props, context) {
    super(props, context)
    this.state = {
      onCertify: props.onCertify
    }
  }

  render() {
    const { account, metadata, link, transaction, errors, editing } = this.props
    const { onCertify } = this.state

    return (
      <div>
        <Row>
          <Col xs={6}>
            <EditableTable
              title="I&E: Period"
              link={link}
              errors={errors}
              editable={editing}
              metadata={metadata}
              account={account}
              onCertify={onCertify}
              data={transaction}
              fields={List([
                'incStYr',
                'incEndYr'
              ])}
            />

            <EditableTable
              title="I&E: Financials"
              link={link}
              errors={errors}
              editable={editing}
              metadata={metadata}
              account={account}
              onCertify={onCertify}
              data={transaction}
              fields={List([
                'grossIncPx',
                'expPx',
                'netIncPx',
                'oprExpRtPct'
              ])}
            />
            <EditableTable
              title="I&E: Cap rate"
              link={link}
              errors={errors}
              editable={editing}
              metadata={metadata}
              account={account}
              onCertify={onCertify}
              data={transaction}
              fields={List([
                'capRtPct'
              ])}
            />
          </Col>

          <Col xs={6}>
            <EditableTable
              title="I&E: Usage"
              link={link}
              errors={errors}
              editable={editing}
              metadata={metadata}
              account={account}
              onCertify={onCertify}
              data={transaction}
              fields={List([
                'propName',
                'useTM',
                'propUse',
                'commodityTM'
              ])}
            />

            <EditableTable
              title="I&E: Expenses"
              link={link}
              errors={errors}
              editable={editing}
              metadata={metadata}
              account={account}
              onCertify={onCertify}
              data={transaction}
              fields={List([
                'maintPx',
                'utilPx',
                'taxesPx',
                'insurPx'
              ])}
            />

            <EditableTable
              title="I&E: NRA"
              link={link}
              errors={errors}
              editable={editing}
              metadata={metadata}
              account={account}
              onCertify={onCertify}
              data={transaction}
              fields={List([
                'netRntSf'
              ])}
            />
          </Col>
        </Row>

        <EditableTable
          link={link}
          errors={errors}
          editable={editing}
          metadata={metadata}
          account={account}
          onCertify={onCertify}
          data={transaction}
          fields={List([
            'dataSrc',
            'linksM',
            'remarks',
            'rediRemarks'
          ])}
        />
      </div>
    )
  }
}

export default TransactionDetail(IncExpDetail, {
  type: 'incexp',
  calcMap: {
    grossIncPx (transaction, keyPath, value) {
      let grossIncPxVal = transaction.get('grossIncPx')
      let expPxVal = transaction.get('expPx')

      switch (R.last(keyPath)) {
        case 'grossIncPx':
          grossIncPxVal = ensureNumber(value)
          break
        case 'expPx':
          expPxVal = ensureNumber(value)
          break
      }

      if (grossIncPxVal && expPxVal) {
        transaction.set('netIncPx', (grossIncPxVal - expPxVal).toFixed(2))
        transaction.set('oprExpRtPct', (grossIncPxVal / expPxVal).toFixed(1))
      }
    },
    expPx (...args) { this.grossIncPx(...args) },
    netIncPx (transaction, keyPath, value) {
      const grossIncPxVal = ensureNumber(transaction.get('grossIncPx'))
      const expPxVal = ensureNumber(transaction.get('expPx'))

      if (!grossIncPxVal && expPxVal) {
        transaction.set('expPx', (ensureNumber(value) - expPxVal).toFixed(2))
      }
      else if (grossIncPxVal && !expPxVal) {
        transaction.set('grossIncPxVal', (grossIncPxVal - ensureNumber(value)).toFixed(2))
      }
      else if (grossIncPxVal && expPxVal) {
        transaction.set('expPx', (grossIncPxVal - ensureNumber(value)).toFixed(2))
      }
    }
  }
})



// WEBPACK FOOTER //
// ./modules/shared/pages/record/incExpDetail.js